/**
 * Created by panwei on 2017/11/21.
 */
// @i18n-ignore-all
import { app as api } from '@ekuaibao/whispered'
import { getCurrencyRatesById, getCurrencyInfoById, getCurrencyModifiable } from './currency-manage-action';

export default [
  {
    id: '@currency-manage',
    reducer: () => import('./currency-manage.reducer'),
    path: '/currency-manage',
    ref: '/',
    onload: () => import('./currency-manage-view'),

    'get:currency:rates:by:Id'(param) {
      return api.dispatch(getCurrencyRatesById(param))
    },

    'get:currency:info:by:id'(params) {
      return getCurrencyInfoById(params)
    },
    'get:currency:modifiable'() {
      return getCurrencyModifiable()
    }

  },
  {
    point: '@@layers',
    prefix: '@currency-manage',
    onload: () => import('./layers'),
  },
  {
    point: '@@menus',
    onload: () => [
      {
        id: 'currency-manage',
        pId: 'enterprise-manage',
        powers: ['Currency'],
        permissions: ['SYS_ADMIN'],
        weight: 14,
        label: '多币种',
        href: '/currency-manage',
        icon: 'currency-manage',
      },
    ],
  },
]
